$('#heroSlider').slick({
   slidesToShow: 1,
   slidesToScroll: 1,
   autoplay: true,
   mobileFirst: true,
   dots: true,
   prevArrow: "",
   nextArrow: "" ,
   verticalSwiping: true,
   vertical: true,
   speed: 1000,
   autoplaySpeed: 3000,
});


const catOptions = {
   dots: false,
   infinite: true,
   mobileFirst: true,
   slidesToShow: 2,
   slidesToScroll: 1,
   prevArrow: '<i class="fa fa-chevron-left"></i>',
   nextArrow: '<i class="fa fa-chevron-right"></i>',
   responsive: [{
         breakpoint: 767,
         settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true
         }
      },
      {
         breakpoint: 1200,
         settings: {
            slidesToShow: 6,
            slidesToScroll: 1,
            infinite: true
         }
      }
   ]
}

$('#popularCat').slick(catOptions);

const catOptions2 = {
   dots: false,
   infinite: true,
   mobileFirst: true,
   slidesToShow: 1,
   slidesToScroll: 1,
   prevArrow: '<i class="fa fa-chevron-left"></i>',
   nextArrow: '<i class="fa fa-chevron-right"></i>',
   responsive: [{
         breakpoint: 767,
         settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true
         }
      },
      {
         breakpoint: 1200,
         settings: {
            slidesToShow: 5,
            slidesToScroll: 1,
            infinite: true
         }
      }
   ]
}

const catOptions3 = {
   dots: false,
   infinite: true,
   mobileFirst: true,
   slidesToShow: 1,
   slidesToScroll: 1,
   prevArrow: '',
   nextArrow: '<i class="fa fa-chevron-right"></i>',
   responsive: [{
         breakpoint: 767,
         settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true
         }
      },
      {
         breakpoint: 1200,
         settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: true
         }
      }
   ]
}

$('.jsCatSlider').each(function( index ) {
   $(this).slick(catOptions2);
 });
 $('.jsCatSliderProd').each(function( index ) {
   $(this).slick(catOptions3);
 });

